



























import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyKey from "@/components/company-key";
import FormHeader from '../../molecules/FormHeader.vue'

export default createComponent({
  setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
    const getEvaluationInfor = company.getEvaluationInfor;
    onMounted(() => {
      getEvaluationInfor()
    });

    const companyInfor = computed(() => company.companyInformation);
    const tableInfor = computed(() => company.tableEvaluationList);
    const evaluationInfor = computed(() => company.companyInformation.evaluationInforList);
    
    return {
      companyInfor,
      evaluationInfor,
      tableInfor
    };
  },

   components : {
    FormHeader,
  },
}
)
